import Sort from './Sort';
import Enum from '../enums/Enum';

export default class Filter {
  constructor(data) {
    // ページ番号
    this.page = data?.page ?? 1;

    // 表示件数
    this.limit = data?.limit ?? 50;

    // 並び替え
    this.sorts = [];
    if (data) {
      // 配列として渡された場合
      // INFO: Vue Routerのパーサーは同じキーのクエリが複数あれば配列として返す（[]を見て判断しない）
      if (data['sorts[]'] instanceof  Array) {
        data['sorts[]']?.forEach(sort => {
          const [key, direction] = sort.split(' ');
          this.sorts.push(new Sort({ key, direction}));
        });
      }

      // 値として渡された場合
      else if (data.hasOwnProperty('sorts[]')) {
        const [key, direction] = data['sorts[]'].split(' ');
        this.sorts.push(new Sort({ key, direction}));
      }
    }
  }

  /**
   * Vue Routerのroute用のオブジェクトを作成
   */
  toQuery() {
    const query = {};
    for (const [key, prop] of Object.entries(this)) {
      // 空の値または配列はスキップ
      if (prop === null || prop === undefined || prop.length === 0) {
        continue;
      }

      // ソート（例：sorts[]=name+asc&sorts[]=price+desc&...）
      if (key === 'sorts') {
        query['sorts[]'] = Object.keys(prop)
          .sort((a, b) => prop[b].priority - prop[a].priority)
          .map(sortKey => {
            const direction = prop[sortKey].direction;
            if (direction === 'asc' || direction === 'desc') {
              return sortKey + ' ' + direction;
            }
          })
          .filter(item => item);
      }

      // Enum
      else if (prop instanceof Enum) {
        query[key] = prop.toString();
      }

      // 日付
      // REVIEW: 「prop instanceof dayjs」だと利用アプリ内でimportしたdayjsオブジェクトにマッチしない
      else if (typeof prop.toISOString === 'function') {
        query[key] = prop.format('YYYY-MM-DD HH:mm:ss');
      }

      // オブジェクト
      // TODO: 入れ子に対応する
      else if (prop instanceof Object) {
        for (const[subKey, subProp] of Object.entries(prop)) {
          query[key + '[' + subKey + ']'] = subProp;
        }
      }

      // 真偽値
      else if (prop instanceof Boolean) {
        query[key] = prop ? 1 : 0;
      }

      // その他の配列
      else if (prop instanceof Array) {
        prop.forEach(item => {
          if (!query.hasOwnProperty(key)) {
            query[key] = [];
          }
          query[key].push(item);
        });
      }

      // 普通の値
      else {
        query[key] = prop;
      }
    }

    return query;
  }

  /**
   * APIリクエスト用のクエリ文字列を作成
   *
   * @returns {string}
   */
  toQueryString() {
    const items = [];

    const query = this.toQuery();

    for (const [key, prop] of Object.entries(query)) {
      if (prop instanceof Array) {
        prop.forEach(value => {
          items.push(key + '=' + value);
        })
      } else {
        items.push(key + '=' + prop);
      }
    }

    return items.join('&');
  }

  /**
   * 検索条件が指定してあるか
   *
   * @returns {boolean}
   */
  hasConditions() {
    // ソートおよびページ番号以外で空でない属性があるか
    for (const [key, prop] of Object.entries(this)) {
      if (key !== 'sorts' && key !== 'page' && key !== 'limit' && prop !== null && prop !== undefined) {
        return true;
      }
    }

    return false;
  }
}
